import Alcada from '../../spa/alcada/AlcadaCadastro';

export default {
  path: 'alcada',
  name: 'alcada',
  component: Alcada,
};
